
import React, { Component } from "react";
import { Pagination, Input, Menu, Dropdown } from '@platform/base';
import { getSysFieldid, getMultiLang, formatAcuracy, formatNumber } from '@platform/api';
import classNames from 'classnames';
const MAX_BUTTONS = 5;
import './index.less';
import PropTypes from "prop-types";

const { Item } = Menu;

export default function pagination(Table) {
    return class PaginationWrapper extends Component {
        static defaultProps = {
            pageInfo: {},
        };

        static propTypes = {
            pageInfo: PropTypes.object,
            pageInfoChange: PropTypes.function,
        };

        constructor(props) {
            super(props);
            this.state = {
                json: {},
                pageSizeVal: '',
                visibleDropDown: false,
            };
            this.options = ['10', '20', '50', '100'];

        }

        UNSAFE_componentWillMount() {
            //加载多语
            let callback = json => {
                let pageSizeVal = this.props.pageInfo && this.props.pageInfo.pageSize;
                pageSizeVal = pageSizeVal + ' ' + json['pagination003'] + '/' + json['pagination001'];
                this.setState({
                    json,
                    pageSizeVal,
                });
            };
            getMultiLang({ moduleId: 'table_lib_pagination', callback });
        }

        UNSAFE_componentWillReceiveProps(nextProps) {
            if (nextProps.pageInfo && nextProps.pageInfo.pageSize) {
                if (!this.props.pageInfo || nextProps.pageInfo.pageSize != this.props.pageInfo.pageSize) {
                    let json = this.state.json;
                    this.setState({ pageSizeVal: nextProps.pageInfo.pageSize + ' ' + json['pagination003'] + '/' + json['pagination001'] });
                }
            }

        }

        //pageIndex事件
        pageIndexChange = val => {
            let { pageInfoChange, pageInfo } = this.props;
            let { total, pageSize } = pageInfo;
            //更新 pageInfo
            let newPageInfo = {
                ...pageInfo,
                pageIndex: val,
                totalPage: Math.ceil(total / pageSize),
            };

            if (typeof pageInfoChange === 'function') {
                pageInfoChange(newPageInfo);
            }
        };

        // pageSize事件
        pageSizeChange = val => {
            let { pageInfoChange, pageInfo } = this.props;
            let { total } = pageInfo;
            let newPageInfo = {
                ...pageInfo,
                pageIndex: 1,
                pageSize: +val,
                totalPage: Math.ceil(total / val),
            }

            if (typeof pageInfoChange === 'function') {
                pageInfoChange(newPageInfo);
            }
        };

        //多余5个页签显示更多按钮
        getOptions = () => {
            let { json, pageSizeVal } = this.state;
            let pageSize = String(pageSizeVal).replace(' ' + json['pagination003'] + '/' + json['pagination001'], '');
            return (
                <Menu
                // onSelect={({ key }) => {
                //     this.pageSizeChange(key);
                //     this.setState({
                //         pageSizeVal: key + ' ' + json['pagination003'] + '/' + json['pagination001'],
                //         visibleDropDown: false,
                //     });
                // }}
                >
                    {this.options.map(item => {
                        return (
                            <Item
                                key={item}
                                onClick={({ key } = item) => {
                                    if (key != this.state.pageSizeVal) {
                                        this.pageSizeChange(key);
                                    }
                                    this.setState({
                                        pageSizeVal: key + ' ' + json['pagination003'] + '/' + json['pagination001'],
                                        visibleDropDown: false,
                                    });
                                }}
                                className={pageSize == item ? 'active-option pagination-option' : 'pagination-option'}
                            >
                                <div className="pagination-size">
                                    {`${item} ${' ' + json['pagination003']}/${json['pagination001']}`}
                                </div>
                            </Item>
                        );
                    })}
                </Menu>
            );
        };

        render() {
            let { json } = this.state;
            let { pageInfo, checkNum, checkTotal, showPagination = false, showPageSizeOption = true, maxPageSize = 5000 } = this.props;
            let { pageSize, total, totalPage, pageIndex } = pageInfo;
            //用户自定义录入得分页条数也显示 '条/页'
            if (!this.options.includes(String(pageSize))) {
                pageSize = pageSize + ' ' + json['pagination003'] + '/' + json['pagination001'];
            }
            let totolRowNumber, totolRowLength;
            if (checkTotal) {
                let { activeNumberTotal, activeRowScale, activeRowTotal } = checkTotal();
                if (activeNumberTotal) {
                    totolRowNumber = formatNumber(formatAcuracy(activeNumberTotal, activeRowScale));
                    totolRowLength = activeRowTotal;
                }

            }
            return (
                <React.Fragment>
                    <Table {...this.props} />
                    {showPagination && <div
                        className="pagination-wrapper"
                        fieldid={getSysFieldid("pagination-div")}
                    >
                        <div className="pagination-size pagination-input-wrapper">
                            {!showPageSizeOption ?
                                <Input
                                    value={this.state.pageSizeVal}
                                    title={this.state.pageSizeVal}
                                    className="pagination-input"
                                    onFocus={(e, val) => {
                                        let pageSize = val.replace(' ' + json['pagination003'] + '/' + json['pagination001'], '');
                                        if (pageSize) {
                                            this.setState({ pageSizeVal: pageSize });
                                        }
                                    }}
                                    onChange={val => {
                                        let pageSize = val === '' ? '' : Number(val);
                                        if (!isNaN(pageSize) || pageSize === '') {
                                            this.setState({ pageSizeVal: pageSize });
                                        }
                                    }}
                                    onBlur={val => {
                                        // 自定义录入每页条数完成后的回调
                                        let pageSize = val === '' ? '' : Number(val);
                                        if (!isNaN(pageSize) || pageSize === '') {
                                            if (pageSize > maxPageSize) {
                                                pageSize = maxPageSize;
                                            }
                                            this.setState({ pageSizeVal: pageSize + ' ' + json['pagination003'] + '/' + json['pagination001'] });
                                            this.pageSizeChange(pageSize);
                                        }
                                    }}
                                    onEnter={({ e } = param) => {
                                        // 自定义录入每页条数完成后的回调
                                        if (e && e.target) {
                                            e.target.blur();
                                        }
                                    }}
                                >
                                </Input>
                                :
                                <React.Fragment>
                                    <Dropdown
                                        trigger={['focus']}
                                        overlay={this.getOptions()}
                                        overlayClassName={'pagination-select-dropdown'}
                                        visible={this.state.visibleDropDown}
                                        onVisibleChange={() => {
                                            this.selectOption = true;
                                        }}
                                    >
                                        <Input
                                            value={this.state.pageSizeVal}
                                            className="pagination-input"
                                            title={this.state.pageSizeVal}
                                            onFocus={e => {
                                                if (e && e.target && e.target.value) {
                                                    let value = e.target.value;
                                                    if (value) {
                                                        let pageSize = value.replace(' ' + json['pagination003'] + '/' + json['pagination001'], '');
                                                        this.setState({
                                                            pageSizeVal: pageSize,
                                                            visibleDropDown: true,
                                                        });
                                                    }

                                                }
                                            }}
                                            onChange={val => {
                                                this.selectOption = false;
                                                let pageSize = val === '' ? '' : Number(val);
                                                if (!isNaN(pageSize) || pageSize === '') {
                                                    this.setState({
                                                        pageSizeVal: pageSize,
                                                        visibleDropDown: false,
                                                    });
                                                }
                                            }}
                                            onBlur={val => {
                                                // 自定义录入每页条数完成后的回调
                                                //判断只有手动录入的才执行blur，若时执行了 select 则不执行 Blur
                                                let pageSize = val === '' ? '' : Number(val);
                                                if (!isNaN(pageSize) || pageSize === '') {
                                                    if (pageSize > maxPageSize) {
                                                        pageSize = maxPageSize;
                                                    }
                                                    if (!this.selectOption) {
                                                        this.setState({
                                                            pageSizeVal: pageSize + ' ' + json['pagination003'] + '/' + json['pagination001'],
                                                            visibleDropDown: false,
                                                        });
                                                        this.pageSizeChange(pageSize);
                                                    } else {
                                                        //即没有录入 也没有选择下拉
                                                        setTimeout(() => {
                                                            if (this.state.visibleDropDown) {
                                                                this.setState({
                                                                    pageSizeVal: pageSize + ' ' + json['pagination003'] + '/' + json['pagination001'],
                                                                    visibleDropDown: false,
                                                                });
                                                            }
                                                        }, 300);
                                                    }
                                                }
                                            }}
                                            onEnter={({ e } = param) => {
                                                // 自定义录入每页条数完成后的回调
                                                if (e && e.target && e.target.value) {
                                                    e.target.blur();
                                                }
                                            }}
                                        >
                                        </Input>
                                    </Dropdown>
                                    <i
                                        className={classNames({
                                            'iconfont select-icon icon-jiantouxia1': true,
                                            'select-open': this.state.visibleDropDown,
                                            'select-close': !this.state.visibleDropDown,
                                        })}
                                    ></i>
                                </React.Fragment>
                            }
                            {!!+total && (
                                <span className="pagination-total">
                                    {json['pagination002']}<span>&nbsp;{total}</span>{' ' + json['pagination003']}
                                    {checkNum && <span style={{ marginLeft: '1px' }}>&nbsp;{json['pagination004']} {checkNum()}{' ' + json['pagination003']}</span>}
                                    {totolRowNumber && <span style={{ marginLeft: '10px' }}>{'计数=' + totolRowLength}</span>}
                                    {totolRowNumber && <span style={{ marginLeft: '10px' }}>{'求和='}{totolRowNumber}</span>}

                                </span>
                            )}
                        </div>
                        <div className="pagination">
                            <Pagination
                                prev
                                next
                                boundaryLinks
                                items={Number(totalPage || 1)}
                                /*分页器按钮：最多显示7个按钮, 当页数>7时 左侧最多显示5个按钮 等于7时 左侧最多显示6个按钮*/
                                maxButtons={Number(totalPage || 1) === 7 ? 6 : MAX_BUTTONS}
                                activePage={Number(pageIndex)}
                                onSelect={this.pageIndexChange}
                            />
                        </div>
                    </div>}
                </React.Fragment>
            );
        }
    }
}